/* Albo Flora - Filtrage du catalogue d'accueil sans changer de page.
 * Intercepte les liens de la sidebar (data-albo-catalog) et charge
 * /collections/<handle>?view=albo en fond. Sans JS, les liens naviguent
 * normalement vers les pages collections (progressive enhancement).
 */
(() => {
  const root = document.querySelector('[data-albo-catalog]');
  if (!root) return;

  const gridWrap = root.querySelector('[data-albo-grid-wrap]');
  const countEl = root.querySelector('[data-albo-count]');
  const links = Array.from(root.querySelectorAll('.albo-cats__link'));
  if (!gridWrap || links.length === 0) return;

  const VIEW = root.dataset.alboView || 'albo';
  let controller = null;

  function withView(url) {
    const u = new URL(url, window.location.origin);
    u.searchParams.set('view', VIEW);
    return u.pathname + u.search;
  }

  function setActive(link) {
    links.forEach((l) => {
      const on = l === link;
      l.classList.toggle('albo-cats__link--active', on);
      if (on) {
        l.setAttribute('aria-current', 'page');
      } else {
        l.removeAttribute('aria-current');
      }
    });
  }

  function handleFromLink(link) {
    try {
      const parts = new URL(link.href, window.location.origin).pathname.split('/');
      return parts[parts.length - 1];
    } catch (e) {
      return null;
    }
  }

  async function load(path, link, scroll) {
    if (controller) controller.abort();
    controller = new AbortController();
    root.classList.add('is-loading');
    gridWrap.removeAttribute('data-albo-error');

    try {
      const res = await fetch(path, {
        signal: controller.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-albo-grid]');
      if (!fresh) throw new Error('missing grid');

      gridWrap.innerHTML = '';
      gridWrap.appendChild(document.importNode(fresh, true));

      if (link) {
        setActive(link);
        const handle = handleFromLink(link);
        if (handle) {
          try {
            history.replaceState(null, '', '#' + handle);
          } catch (e) {
            /* ignore */
          }
        }
      }
      if (countEl && fresh.dataset.countText) {
        countEl.textContent = fresh.dataset.countText;
      }
      if (scroll) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } catch (e) {
      if (e && e.name !== 'AbortError') {
        gridWrap.setAttribute('data-albo-error', '1');
      }
    } finally {
      root.classList.remove('is-loading');
    }
  }

  // Clic sur une catégorie : reste sur l'accueil, remplace la grille.
  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      load(withView(link.pathname), link, true);
    });
  });

  // Pagination dans la grille chargée : reste sur place.
  gridWrap.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a || !/[?&]page=/.test(a.getAttribute('href'))) return; // seulement la pagination, pas les produits
    e.preventDefault();
    load(withView(a.getAttribute('href')), null, true);
  });

  // Accès direct avec ancre (#monstera) : charge la collection au démarrage.
  if (window.location.hash) {
    const handle = window.location.hash.slice(1);
    const match = links.find((l) => handleFromLink(l) === handle);
    if (match) load(withView(match.pathname), match, false);
  }
})();
